<template>
  <div>
    <!-- {{ searchObject }} -->
    <!-- top: {{ topCode ? topCode.code : null }}, search: {{ search }}, sevenChar:
    {{ sevenChar }}, isPenultimate: {{ isPenultimate }} -->
    <router-link
      to="/icd10/diabetic-retinopathy-widget"
      v-if="isDiabetesCode && isMobile"
    >
      <v-card color="#ffd5e3" flat class="py-2 px-4 mt-4">
        Find diabetic retinopathy codes faster with the
        <span class="linkLike">Diabetic Retinopathy Widget!</span>
      </v-card></router-link
    >

    <div class="mx-0 mx-sm-1">
      <div v-if="loading"><loading></loading></div>
      <div v-else-if="error">Error loading data</div>
      <v-fade-transition>
        <div v-if="codes && meta">
          <div>
            <icd-header
              v-if="meta.searchObj"
              :meta="meta"
              :codes="codes"
              :sevenChar="sevenChar"
            ></icd-header>
            <icd-header
              v-else
              :title="title"
              :meta="meta"
              :codes="codes"
              :simple="true"
            >
            </icd-header>

            <!-- penultimate: {{ isPenultimate }} -->
            <!-- 
          {{ codesForWidget }} -->
            <!-- note: widget only shown here if the searched code is a penultimate code -->
            <div class="d-flex flex-row justify-space-between">
              <div class="mr-2">
                <!-- {{ meta.tree }}<br />
                sevenChar:{{ sevenChar }}<br />
                topCodeSevenChar:{{ topCodeSevenChar }}<br />
                isPenultimate: {{ isPenultimate }} -->
                <icd-widget
                  v-if="isPenultimate"
                  :codes="codesForWidget"
                  :parentObj="searchedObject"
                  :sevenChar="sevenChar || topCodeSevenChar"
                  :expandAll="true"
                ></icd-widget>

                <!-- <icd-item
                  v-if="
                    meta.tree.length == 0 && (sevenChar || topCodeSevenChar)
                  "
                  :theKey="search"
                  :codes="codes"
                  :meta="meta"
                  :makeLink="abridged"
                  :sevenChar="sevenChar || topCodeSevenChar"
                ></icd-item> -->

                <code-with-7
                  v-else-if="
                    searchObject &&
                    topCodeSevenChar &&
                    searchObject.descendants == '0'
                  "
                  :label="searchObject.name"
                  :sevenChar="topCodeSevenChar"
                  :code="searchObject.code"
                ></code-with-7>

                <icd-tree-element
                  v-else
                  :meta="meta"
                  :codes="codes"
                  :tree="meta.tree"
                  :sevenChar="sevenChar"
                ></icd-tree-element>

                <icd-see-also :codes="codes"></icd-see-also>
              </div>
              <!-- <v-spacer></v-spacer> -->
              <div v-if="!isMobile">
                <router-link
                  to="/icd10/diabetic-retinopathy-widget"
                  v-if="isDiabetesCode"
                  class=""
                >
                  <v-card color="#ffd5e3" flat class="py-2 px-4 mx-2 mb-3">
                    Find diabetic retinopathy codes faster with the
                    <span class="linkLike">Diabetic Retinopathy Widget!</span>
                  </v-card></router-link
                >
                <see-also
                  v-if="search"
                  :identifier="search"
                  identifier_type="ICD10"
                  referrer="ICD10"
                  class="my-2"
                ></see-also>
              </div>
            </div>
            <see-also
              v-if="search && !isCollection && isMobile"
              :identifier="search"
              identifier_type="ICD10"
              referrer="ICD10"
              class="my-2"
            ></see-also>
          </div>
        </div>
      </v-fade-transition>
    </div>

    <!-- {{ topCode }} -->
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import IcdObjectMixin from "@/assets/js/icd/IcdObjectMixin";

export default {
  name: "IcdRange",
  components: {
    IcdHeader: () => import("./IcdHeader"),
    IcdTreeElement: () => import("@/components/icdStuff/IcdTreeElement"),
    Loading: () => import("@/components/universalStuff/Loading.vue"),
    IcdWidget: () => import("@/components/icdStuff/IcdWidget"),
    // IcdAliasList: () => import("@/components/icdStuff/IcdAliasList"),
    IcdSeeAlso: () => import("@/components/icdStuff/IcdSeeAlso"),
    SeeAlso: () => import("@/components/universalStuff/SeeAlso.vue"),
    // IcdItem: () => import("@/components/icdStuff/IcdItem"),
    CodeWith7: () => import("@/components/icdStuff/CodeWith7"),
  },
  mixins: [IcdObjectMixin],
  props: {
    search: null,
    isCollection: null,
  },
  data: function () {
    return {
      loading: false,
      error: false,
      meta: null,
      codes: null,
      title: "ICD Codes",
      diabetesCodes: ["E08", "E09", "E10", "E11", "E13"],
    };
  },
  methods: {
    callApi(range) {
      this.loading = true;
      ApiServices.codeDetails(range)
        .then((response) => {
          this.codes = response.data.results;
          this.meta = response.data.meta;
          this.loading = false;
          this.error = false;
          let title = response.data?.meta["title"];
          if (title) this.title = title;
          if (this.meta.aliases) this.$emit("aliases", this.meta.aliases);
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.loading = false;
        });
    },
  },
  computed: {
    // aliasList: function () {
    //   if (!this.meta.aliases) return null;
    // },
    queryTitle: function () {
      let title = null;
      if (!this.meta?.title && this.$route.query?.title)
        title = this.$route.query.title;
      return title;
    },
    topCode: function () {
      if (!this.codes) return null;
      let code1 = Object.keys(this.codes)[0];
      return this.codes[code1];
    },
    // if the top level code has a sevenChar get it to pass on to the tree
    topCodeSevenChar: function () {
      if (!this.codes) return null;
      return this.keyValueForObj(this.topCode, "sevenChar"); // from IcdObjectMixin
    },
    sevenChar: function () {
      if (!this.meta?.searchObj) return null;
      return this.keyValueForObj(this.searchedObject, "sevenChar"); // from IcdObjectMixin
    },
    // if the "searched for" code is a penultimate code
    isPenultimate: function () {
      if (!this.meta?.searchObj) return null;
      return this.keyValueForObj(this.searchedObject, "penultimate") == "1"; // from IcdObjectMixin
    },
    // if the "searched for" code is a penultimate code we'll use these codes in the widget
    codesForWidget: function () {
      if (!this.codes || !this.meta) return null;
      let codeKeys = Object.keys(this.meta.tree);
      let rtn = {};
      for (const codeKey of codeKeys) {
        rtn[codeKey] = this.codes[codeKey];
      }
      return rtn;
    },
    searchObject: function () {
      if (!this.search || !this.codes) return null;
      return this.codes[this.search];
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    isDiabetesCode: function () {
      if (!this.search) return false;
      let rtn = null;
      this.diabetesCodes.forEach((code) => {
        if (this.search.includes(code)) rtn = true;
      });
      return rtn;
    },
    // seeAlsoCode: function () {
    //   let rtn = null;
    //   if (this.search) {
    //     rtn = this.search.includes("-") ? this.search.split("-") : this.search;
    //   }
    //   // else if (this.codes) {
    //   //   rtn = Object.keys(this.codes)[0];
    //   // }
    //   return rtn;
    // },
  },
  mounted: function () {
    if (this.search) this.callApi(this.search);
    if (this.$route.query?.title) this.title = this.$route.query.title;
  },
  watch: {
    search(val) {
      if (val) this.callApi(val);
    },
  },
  metaInfo() {
    return {
      title: "EyeDock/ICD10 | " + this.title,
    };
  },
};
</script>

<style scoped>
/* .chapterName {
  max-width: 800px;
} */
.codeLink {
  text-decoration: none;
}
</style>
